import React from "react";
import './Endpoints.css';
import authService from "./AuthService";
import config, { getApiUrl } from "./config";
import {Link} from "react-router-dom";
import toast from "react-hot-toast";

type EndpointsProperties = {}

export type Endpoint = {
    endpointId: string,
    friendlyName: string,
    online: boolean,
    state: string,
    descriptionPending: boolean,
}

type EndpointsState = {
    endpoints: Array<Endpoint>
    newEndpointFriendlyName: string | undefined
}

class Endpoints extends React.Component<EndpointsProperties, EndpointsState> {
    private updateIntervalId: number | undefined;

    constructor(props: EndpointsProperties) {
        super(props);
        this.state = {
            endpoints: new Array<Endpoint>(),
            newEndpointFriendlyName: undefined
        }
    }

    componentDidMount() {
        this.fetchEndpoints();
        this.updateIntervalId = window.setInterval(() => this.fetchEndpoints(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.updateIntervalId);
    }

    private createNewEndpoint = () => {
        let friendlyName = this.state.newEndpointFriendlyName;
        let body: any = {};
        if (friendlyName !== undefined && friendlyName.length > 0) {
            body.friendlyName = friendlyName;
        }
        console.log(body);
        this.setState({newEndpointFriendlyName: undefined});
        fetch(getApiUrl() + "/v1/endpoint/", {
            "method": "POST",
            headers: [
                ["Content-Type", "application/json"],
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ],
            body: JSON.stringify(body)
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Failed to create endpoint");
                }
                return res.json() as Promise<Endpoint>
            })
            .then((endpoint) => {
                toast.success("Endpoint created successfully");
            })
            .catch(() => {
                toast.error("Failed to create endpoint");
            });
    }

    render() {
        return (
            <div className="Endpoints">
                <h2>Endpoints</h2>
                {this.state.endpoints.length > 0 ? <div className="Endpoints-list">
                    {this.state.endpoints.map((endpoint) => {
                        return (
                            <Link to={"/endpoint/" + endpoint.endpointId}
                                  className={endpoint.online ? "Endpoints-endpoint online" : "Endpoints-endpoint offline"} key={endpoint.endpointId}>
                                {endpoint.friendlyName}<br/><small className="Endpoints-friendlyName">{endpoint.endpointId}</small>
                            </Link>);
                    })}
                </div> : <div className="Endpoints-list">
                    <div className="Endpoints-empty">No endpoints found</div>
                </div>}
                <button className="Home-link" onClick={() => this.setState({newEndpointFriendlyName: ""})}>Add new Endpoint</button>
                {this.state.newEndpointFriendlyName !== undefined && <div className="Endpoints-newEndpoint">
                    <div className="Endpoints-newEndpoint-content">
                        <input type="text" value={this.state.newEndpointFriendlyName} onChange={(ev) => this.setState({newEndpointFriendlyName: ev.target.value})} placeholder="New Endpoint"/>
                        <div className="Endpoints-newEndpoint-buttons">
                            <button onClick={this.createNewEndpoint}>Create</button>
                            <button onClick={() => this.setState({newEndpointFriendlyName: undefined})}>Cancel</button>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }

    private fetchEndpoints() {
        fetch(getApiUrl() + "/v1/endpoint/", {
            headers: [
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(response => response.json() as Promise<Endpoint[]>)
            .then((response) => {
                this.setState({
                    endpoints: response
                })
            })
            .catch((error) => {
                console.error(error);
            });
    }
}

export default Endpoints;
